<div class="header-container">
  <h1 class="header-title">Dashboard</h1>
</div>
<div>
    <iframe #mixpanel width="100%" src="https://eu.mixpanel.com/p/X3p42dJ8LzcHFKWSSXupUs" [frameBorder]="0"></iframe>
</div>
